import React, {useContext} from 'react'
import { GlobalDataContext } from '../../context/context'
import { ButtonContent } from './boton/ButtonContent'

const VideoPromocional = ({ linkVideo, image, title, text }) => {
    const { rpdata } = useContext(GlobalDataContext);

    const buildVideoSrc = (link) => {
        if (!link) return '';

        try {
            // If it's a full URL
            if (/^https?:\/\//i.test(link)) {
                // Vimeo player URL (already embed-ready)
                if (/vimeo.com/i.test(link)) {
                    // Ensure autoplay parameter is present
                    return link.includes('?') ? `${link}&autoplay=1` : `${link}?autoplay=1`;
                }

                // YouTube full URLs
                if (/youtube.com|youtu.be/i.test(link)) {
                    // extract video id
                    const ytMatch = link.match(/(?:v=|\/embed\/|youtu\.be\/)??([A-Za-z0-9_-]{6,})/);
                    const id = ytMatch ? ytMatch[1] : '';
                    return id ? `https://www.youtube.com/embed/${id}?&autoplay=1&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&playlist=${id}` : link;
                }

                // Other URLs: return as-is
                return link;
            }

            // If it's a plain numeric id, assume Vimeo
            if (/^\d+$/.test(link)) {
                return `https://player.vimeo.com/video/${link}?autoplay=1`;
            }

            // Otherwise assume it's a YouTube id
            return `https://www.youtube.com/embed/${link}?&autoplay=1&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&playlist=${link}`;
        } catch (e) {
            return '';
        }
    }

    const videoSrc = buildVideoSrc(linkVideo);

    return (
        <div
            className='bgCountentVideo'
            style={{
                backgroundImage: `url("${image ? image : rpdata?.stock?.[0]}")`
            }}
        >
            <div className='countentVideoInfo '>
                <div className='info'>
                    <h3>{title}</h3>
                    <p>{text}</p>
                    <ButtonContent />
                </div>
                <iframe
                    title="Promotional video"
                    className='w-[90%] h-[280px] md:h-[360px] md:w-[50%] lg:h-[460px] lg:w-[60%] mx-auto rounded-3xl relative top-[80px] md:top-[150px]'
                    id="promotional-player"
                    type="text/html"
                    src={videoSrc}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                />
            </div>
        </div>
    )
}

export default VideoPromocional


